import { theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3';
import styled from 'styled-components';

export const LegalCard = styled(Stack)`
  padding: ${theme.spaces.x20} ${theme.spaces.x20} ${theme.spaces.x16};
  border: 1px solid ${theme.colors.gray200};
  border-radius: ${theme.radius.x12};
  background: ${theme.colors.white};
`;

export const LegalCardDivider = styled.div`
  height: 1px;
  background: ${theme.colors.gray100};
`;
